<div class="kpi-row">
    <div
        class="kpi-item"
        *ngFor="let t of tiles"
        [class.kpi-positive]="t.tone === 'positive'"
        [class.kpi-negative]="t.tone === 'negative'"
    >
        <div class="kpi-head">
            <span class="kpi-arrow" *ngIf="indicator(t)">{{
                indicator(t)
            }}</span>
            <span class="kpi-label">{{ t.label }}</span>
            <span
                *ngIf="t.documentation"
                class="kpi-documentation"
                nz-icon
                nzType="info-circle"
                nzTheme="outline"
                nz-tooltip
                (click)="showTileDocumentation(t)"
            ></span>
        </div>
        <span class="kpi-value">{{
            t.valueFormatter
                ? t.valueFormatter(t.value)
                : (t.value | number: '1.0-0')
        }}</span>
        <div class="kpi-foot">
            <span class="kpi-unit" *ngIf="t.unit">{{ t.unit }}</span>
            <span
                class="kpi-delta"
                *ngIf="t.delta != null"
                [class.kpi-neutral]="deltaTone(t) === 'neutral'"
                [class.kpi-positive]="deltaTone(t) === 'positive'"
                [class.kpi-negative]="deltaTone(t) === 'negative'"
            >
                {{ deltaIndicator(t) }} {{ formatDelta(t) }}
                <span class="kpi-delta-cap" *ngIf="t.deltaCaption">{{
                    t.deltaCaption
                }}</span>
            </span>
        </div>
    </div>
</div>
